import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useHandleActionItem } from "../../../hooks/useHandleActionItem.js";
import InputText from "../../../components/forms/InputText.jsx";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

function SellersDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationType = location.state?.type || "";
	const data = useMemo(() => location.state?.data || [], [location.state?.data]);

	const [seller, setSeller] = useState({
		nombre: "",
		idSucursalAsignada: "",
		horarioDisponible: "",
		telefono: "",
	});
	const { handleDelete, handleSubmit } = useHandleActionItem();

	// Función para convertir datos traducidos a campos originales
	const translateDataToOriginal = (translatedData) => {
		const fieldMapping = {
			"ID Vendedor": "idVendedor",
			"Nombre": "nombre",
			"Teléfono": "telefono",
			"ID Sucursal Asignada": "idSucursalAsignada",
			"Horario Disponible": "horarioDisponible"
		};

		const originalData = {};
		for (const [translatedKey, value] of Object.entries(translatedData)) {
			const originalKey = fieldMapping[translatedKey] || translatedKey;
			originalData[originalKey] = value;
		}
		return originalData;
	};

	useEffect(() => {
		if (locationType === "edit" && data) {
			const originalData = translateDataToOriginal(data);
			setSeller(originalData);
		}
	}, [locationType, data]);

	const validateForm = () => {
		if (!seller.nombre) {
			Toast.fire({
				icon: "error",
				title: "El nombre es obligatorio",
				background: "#1e2836",
			});
			return false;
		}
		return true;
	};

	const handleInputChange = (field, value) => {
		setSeller((prev) => ({ ...prev, [field]: value }));
	};

	const handleSubmitForm = async (event) => {
		event.preventDefault();
		if (!validateForm()) return;
		try {
			if (locationType === "add") {
				await handleSubmit("add", "sellers", seller);
			} else {
				await handleSubmit("update", "sellers", seller);
			}
			navigate("/sellers");
		} catch (error) {
			console.log("ERROR", error);
		}
	};

	const handleDeleteForm = async (event) => {
		event.preventDefault();
		await handleDelete({ idVendedor: seller.idVendedor }, "sellers", true);
	};

	return (
		<div>
			<form onSubmit={handleSubmitForm}>
				<h1 className="text-center">{locationType === "add" ? "Agregar Vendedor" : "Actualizar Vendedor"}</h1>
				<InputText label="Nombre" value={seller.nombre || ""} setValue={(v) => handleInputChange("nombre", v)} />
				<InputText
					label="ID Sucursal Asignada"
					value={seller.idSucursalAsignada || ""}
					setValue={(v) => handleInputChange("idSucursalAsignada", v)}
				/>
				<InputText
					label="Horario Disponible"
					value={seller.horarioDisponible || ""}
					setValue={(v) => handleInputChange("horarioDisponible", v)}
				/>
				<InputText
					label="Teléfono"
					value={seller.telefono || ""}
					setValue={(v) => handleInputChange("telefono", v)}
				/>
				<hr />
				<div className="mb-3 d-flex justify-content-around ">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{locationType === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button onClick={() => navigate("/sellers")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					{locationType === "edit" && (
						<button onClick={handleDeleteForm} className="btn btn-outline-danger btn-lg">
							Eliminar
						</button>
					)}
				</div>
			</form>
		</div>
	);
}

export default SellersDetails;
